import React, { useState } from 'react';
import { useRecoilState } from 'recoil';
import {
  btnColor,
  btnDisabledFlg,
  mainBlueColor,
  workingBudgetInfo,
  workingBudgetVendor
} from '../../GlobalState';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import _ from 'lodash';
import { VenderSelectModal } from './VenderSelectModal';
import { VenderDeleteModal } from './VenderDeleteModal';

type TProps = {
  changeLoggedInData: (newData: string) => void;
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSuccessMessage: React.Dispatch<React.SetStateAction<string>>;
  setOpenSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  workingBudgetId: number;
  DeleteButtonDisabled: boolean;
};
/**
 * ボタンエリア
 * @constructor
 */
export const ButtonArea: React.FC<TProps> = (props: TProps) => {
  const {
    changeLoggedInData,
    setErrorMessage,
    setOpen,
    setSuccessMessage,
    setOpenSuccess,
    workingBudgetId,
    DeleteButtonDisabled
  } = props;

  const [buttonColor] = useRecoilState(btnColor);
  const classes = useStyles({ buttonColor: buttonColor });
  const [disabledFlg] = useRecoilState(btnDisabledFlg);
  const [openSelectModal, setOpenSelectModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  return (
    <div className={classes.container}>
      <div className={classes.right}>
        発注先業者の
        <Button
          style={{ backgroundColor: buttonColor }}
          variant='contained'
          color='primary'
          onClick={() => setOpenSelectModal(true)}
          disabled={disabledFlg}
        >
          追加
        </Button>
        {openSelectModal && (
          <VenderSelectModal
            openSelectModal={openSelectModal}
            setOpenSelectModal={setOpenSelectModal}
            changeLoggedInData={changeLoggedInData}
            setErrorMessage={setErrorMessage}
            setOpen={setOpen}
            setSuccessMessage={setSuccessMessage}
            setOpenSuccess={setOpenSuccess}
            workingBudgetId={workingBudgetId}
          />
        )}
        <Button
          className={classes.redBtn}
          variant='contained'
          color='primary'
          disabled={DeleteButtonDisabled}
          onClick={() => setOpenDeleteModal(true)}
        >
          削除
        </Button>
        {openDeleteModal && (
          <VenderDeleteModal
            openDeleteModal={openDeleteModal}
            setOpenDeleteModal={setOpenDeleteModal}
            changeLoggedInData={changeLoggedInData}
            setErrorMessage={setErrorMessage}
            setOpen={setOpen}
            setSuccessMessage={setSuccessMessage}
            setOpenSuccess={setOpenSuccess}
            workingBudgetId={workingBudgetId}
          />
        )}
      </div>
    </div>
  );
};

type TStyleProps = {
  buttonColor: string;
};

const useStyles = makeStyles<Theme, TStyleProps>((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      width: '100%',
      paddingTop: 10,
      paddingRight: 10
    },
    left: {
      display: 'flex',
      width: '50%',
      gap: 20
    },
    right: {
      display: 'flex',
      width: '100%',
      gap: 20,
      justifyContent: 'flex-end',
      alignItems: 'center'
    },
    redBtn: {
      backgroundColor: '#ff1212',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#ff4444',
        boxShadow: 3
      }
    }
  })
);
